import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from "./baseQuery";
import { IUser, IUserWithStats } from '../model/UserModel';

export interface IChangeContextResponse {
  token: string;
}
export const usersApi = createApi({
  reducerPath: 'Users',
  baseQuery: baseQuery({
    baseUrl: '/user/',
  }),
  tagTypes: ['Users','IUserWithStats'],
  endpoints: (build) => ({
    getUserById: build.query<IUser, string>({
      query: (_id) => (
        {
          url: `get`,
          method: 'POST',
          body: {
            id: _id,
          },
        }),
      providesTags: (result, error, _id) => [{ type: 'Users', _id }],
    }),
    getUsers: build.query<IUser[], void>({
      query: () => (
        {
          url: `list`,
          method: 'GET',
        }),
      providesTags: [{ type: 'Users' }],
    }),
    getUsersWithStats: build.query<IUserWithStats[], void>({
      query: () => (
        {
          url: `list_with_stats`,
          method: 'GET',
        }),
      providesTags: [{ type: 'IUserWithStats' }],
    }),
    updateUser: build.mutation<IUser, Partial<IUser>>({
      query: (data) => ({
        url: `edit`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: (result, error, { _id }) => [{ type: 'Users', _id },'Users','IUserWithStats'],
    }),

    register: build.mutation<IUser, IUser>({
      query: ({ _id, ...data }) => ({
        url: 'register',
        method: 'POST',
        body: data,
      }),
      invalidatesTags: [{ type: 'Users' },'Users','IUserWithStats'],
    }),
  }),
});

export const { useGetUsersQuery, useGetUserByIdQuery, useUpdateUserMutation, useGetUsersWithStatsQuery, useRegisterMutation } = usersApi;
